class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.progress = this.getAttribute('data-progress');
  }

  connectedCallback() {
    setTimeout(() => {
      this.querySelector('[data-progress-line]').style.width = this.progress;
    }, 100);
  }
}
customElements.define('progress-bar', ProgressBar);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    this.onChange = this.onChange.bind(this);
    this.addEventListener('change', this.onChange);

    updateFreeShipping();
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return [
      {
        id: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        }`,
        section:
          document.getElementById('main-cart-items').dataset.id,
        selector: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        } cart-items`
      },
      {
        id: '#cart-counter',
        section: 'cart-counter',
        selector: '#shopify-section-cart-counter'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.classList.add('is-loading');

    const sections = this.getSectionsToRender().map(section => section.section);

    // Single API call: use /cart/change.js with sections, and handle
    // gift sync after render via a fast follow-up only when needed
    const body = JSON.stringify({
      line,
      quantity,
      sections: sections,
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);

        // Render immediately with current state
        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            section.id === '#cart-counter'
              ? document.querySelector(section.id)
              : document.querySelector(section.selector);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        // Gift sync — non-blocking background update
        if (window.GiftSync) {
          const gu = window.GiftSync.getUpdates(parsedState);
          if (gu) {
            // Fire and forget — updates gift in background, then quietly re-renders
            fetch(routes.cart_update_url, {
              ...fetchConfig(),
              body: JSON.stringify({ updates: gu, sections: sections, sections_url: window.location.pathname })
            }).then(r => r.text()).then(s => {
              const u = JSON.parse(s);
              this.getSectionsToRender().forEach(sec => {
                const el = sec.id === '#cart-counter' ? document.querySelector(sec.id) : document.querySelector(sec.selector);
                if (el) el.innerHTML = this.getSectionInnerHTML(u.sections[sec.section], sec.selector);
              });
            });
          }
        }

        // Pre-order ETA sync is handled by global.js (single consolidated sync)
        // NOTE: the previous "pre-order property cleanup" block has been removed
        // because its DOM selector ('.cart-drawer__items [data-variant-id]') no
        // longer matches the rewritten cart drawer markup, which caused it to
        // wrongly strip pre-order properties on every cart change (making the
        // pre-order shipping band disappear). global.js handles any real cleanup.

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        updateFreeShipping();

        document.dispatchEvent(new CustomEvent('cart:change'));
      })
      .finally(() => this.classList.remove('is-loading'));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount) {
    // Only show quantity error if the line item's actual quantity doesn't match
    // what the user requested. The old check (currentItemCount === itemCount)
    // falsely triggers when gift items change the total count.
    const quantityInput = document.querySelector(`[id*="ProductQuantity-${line}"]`);
    if (quantityInput) {
      const lineItem = document.getElementById(`CartItem-${line}`);
      const actualQty = lineItem?.querySelector('[name="updates[]"]')?.value;
      if (actualQty && parseInt(actualQty) !== parseInt(quantityInput.value)) {
        document.querySelectorAll(`[data-line-item-error][data-line="${line}"]`)
          .forEach(error => {
            error.innerHTML = window.cartStrings.quantityError.replace(
              '[quantity]', actualQty
            );
          });
      }
    }

    this.currentItemCount = itemCount;
  }
}

customElements.define('cart-items', CartItems);